function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowToast } from '@rd-web-markets/shared/dist/util/toast/useToast';
const api = buildService('/partnerships/{id}/partnership_parties', {
  only: ['all', 'create', 'update', 'delete']
});
const setPartiesOnPartnership = (setPartnership, parties) => {
  setPartnership(prev => {
    return _objectSpread(_objectSpread({}, prev), {}, {
      partnership_parties: parties
    });
  });
};
const mergePartyIntoPartnership = (setPartnership, partyId, replacement) => {
  setPartnership(prev => {
    const list = prev.partnership_parties || [];
    const next = list.map(party => party.id === partyId ? _objectSpread(_objectSpread({}, replacement), {}, {
      saved: true
    }) : party);
    return _objectSpread(_objectSpread({}, prev), {}, {
      partnership_parties: next
    });
  });
};
const appendPartyToPartnership = (setPartnership, created) => {
  setPartnership(prev => {
    return _objectSpread(_objectSpread({}, prev), {}, {
      partnership_parties: [...(prev.partnership_parties || []), _objectSpread(_objectSpread({}, created), {}, {
        saved: true
      })]
    });
  });
};
const removePartyFromPartnership = (setPartnership, partyId) => {
  setPartnership(prev => {
    return _objectSpread(_objectSpread({}, prev), {}, {
      partnership_parties: (prev.partnership_parties || []).filter(party => party.id !== partyId)
    });
  });
};
const partnershipPartyService = {
  useFetchAll: function (partnershipId, setLoading, setPartnership) {
    let fetchImmediately = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (partnershipId == null) {
          return [];
        }
        const parties = (await api.all(partnershipId)).map(party => _objectSpread(_objectSpread({}, party), {}, {
          saved: true
        }));
        setPartiesOnPartnership(setPartnership, parties);
        return parties;
      }, [partnershipId, setPartnership]),
      setLoading,
      fetchImmediately,
      initialStateValue: []
    });
  },
  useCreate: (partnershipId, setLoading, setPartnership) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const createParty = serviceMethods.useCreate({
      callback: useCallback(async payload => {
        const result = await api.create(partnershipId, {
          partnership_party: payload
        });
        appendPartyToPartnership(setPartnership, result);
        showToast({
          message: t('party_saved')
        });
        return result;
      }, [partnershipId, setPartnership, showToast, t]),
      setLoading
    });
    return [createParty];
  },
  useUpdate: (partnershipId, setLoading, setPartnership) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const updateParty = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        let {
          id,
          partnership_party
        } = _ref;
        const result = await api.update(partnershipId, id, {
          partnership_party
        });
        mergePartyIntoPartnership(setPartnership, id, result);
        showToast({
          message: t('party_saved')
        });
        return result;
      }, [partnershipId, setPartnership, showToast, t]),
      setLoading
    });
    return [updateParty];
  },
  useDelete: (partnershipId, setLoading, setPartnership) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const deleteParty = serviceMethods.useDelete({
      callback: useCallback(async party => {
        if (!window.confirm(t('are_you_sure_you_want_to_delete_this_party'))) return;
        await api.delete(partnershipId, party.id);
        removePartyFromPartnership(setPartnership, party.id);
        showToast({
          message: t('party_deleted')
        });
      }, [partnershipId, setPartnership, showToast, t]),
      setLoading
    });
    return [deleteParty];
  }
};
partnershipPartyService.useCrud = function (partnershipId, setLoading, setPartnership) {
  let fetchImmediately = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const [,, fetchParties] = partnershipPartyService.useFetchAll(partnershipId, setLoading, setPartnership, fetchImmediately);
  const [createParty] = partnershipPartyService.useCreate(partnershipId, setLoading, setPartnership);
  const [updateParty] = partnershipPartyService.useUpdate(partnershipId, setLoading, setPartnership);
  const [deleteParty] = partnershipPartyService.useDelete(partnershipId, setLoading, setPartnership);
  return {
    fetchParties,
    createParty,
    updateParty,
    deleteParty
  };
};
export default partnershipPartyService;